import { PartnerAccountsResp } from '../interfaces/partner-accounts.interface';
import { PartnerLink } from '../interfaces/partner-links.interface';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { PartnersService } from '@app/services/partners.service';
import { CacheService } from '@app/services/cache.service';
import { GenericMessage } from '@app/interfaces/globals';
import { HttpParams } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { handleError } from '@utils/helpers';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PartnerService {
	constructor(
		private partnersService: PartnersService,
		private apiFacade: ApiFacadeService,
		private cache: CacheService,
	) {}

	public getAccounts(partnerId?: string): Observable<PartnerAccountsResp> {
		const url = 'frontend/reseller/get-accounts';
		let params = new HttpParams();
		if (!!partnerId) {
			params = params.set('reseller_id', partnerId);
		}
		return this.apiFacade
			.get<PartnerAccountsResp>(url, { params })
			.pipe(catchError((err) => handleError(err, {} as PartnerAccountsResp)));
	}

	public generateLinks(options): Observable<{ csv: string; links: PartnerLink[] }> {
		const url = 'frontend/reseller/generate-links';
		const payload = {
			reseller_id: options.reseller_id,
			linksAmount: options.linksAmount || 1,
			organization: options.organization,
			permissionsLevel: options.permissionsLevel,
			accountsNames: options.accountsNames,
			accountsUuids: options.accountsUuids,
			permissions: options.permissions || [],
			features_list: options.features_list,
			is_reonboard: options.is_reonboard,
			has_existing_cur: options.has_existing_cur,
			cur_bucket_name: options.cur_bucket_name,
			region: options.region,
		};

		return this.apiFacade
			.post<{ csv: string; links: PartnerLink[] }>(url, payload)
			.pipe(catchError((err) => handleError(err, null)));
	}

	public addOrganization(company: string): Observable<GenericMessage> {
		const url = 'frontend/reseller/add-organization';
		return this.apiFacade.post<GenericMessage>(url, { company });
	}

	public deleteLink(uuid: string): Observable<{ Success: boolean }> {
		const url = 'frontend/reseller/delete-link';
		return this.apiFacade.post<{ Success: boolean }>(url, { uuid }).pipe(catchError((err) => handleError(err, null)));
	}

	public selectOU(org_id: string, selectedOU: string) {
		const url = 'frontend/reseller/select-ou';
		return this.apiFacade.post<any>(url, { org_id, selectedOU }).pipe(catchError((err) => handleError(err, null)));
	}

	public checkARN(uuid: string, arn: number): Observable<any> {
		const url = 'frontend/reseller/check-arn';
		return this.apiFacade.post<GenericMessage>(url, { uuid, arn }).pipe(catchError((err) => handleError(err, null)));
	}

	public getEverAfterLink(email, accountId): Observable<string> {
		const url = 'frontend/report/everafter-link';
		const cacheKey = 'partner-everafter-link';

		if (this.cache.get(cacheKey)) {
			return of(this.cache.get(cacheKey));
		}
		return this.apiFacade.post<string>(url, { email, accountId }).pipe(tap((str) => this.cache.set(cacheKey, str)));
	}

	public get isAllowedToSelectPartner(): boolean {
		return this.partnersService.isAllowedToSelectPartner;
	}
}
